import React, { useRef, useEffect, useState } from 'react';
import '../CustomCSS/Ayurvedham.css';

const Ayurvedham = () => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setVisible(entry.isIntersecting),
      { threshold: 0.3 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id='ayurvedham'
      ref={sectionRef}
      className={`ayurvedham-section ${visible ? 'animate' : ''}`}
    >
      <div className="ayurvedham-text">
        <h2>Discover Ayurvedham</h2>
        <p>
          <strong>Origin & History:</strong> Ayurvedham draws inspiration from the ancient Indian science of Ayurveda, 
          practiced for over 5000 years. Rooted in Vedic traditions, it emphasizes natural healing, 
          balance of body, mind, and spirit, and preventive care for long-lasting wellness.
        </p>
        <p>
          <strong>Our Approach:</strong> We combine traditional Ayurvedic therapies with modern health insights, 
          creating personalized wellness plans that suit your lifestyle.
        </p>
        <p>
          <strong>Benefits:</strong> Boost immunity, improve digestion, enhance vitality, reduce stress, 
          and achieve holistic well-being through natural treatments and lifestyle guidance.
        </p>
      </div>

      <div className="ayurvedham-image-box">
        <div className="ayurvedham-overlay">
          <div className="ayurvedham-quote">
            स्वास्थ्यं सर्वस्य मूलम्, आयुर्वेदं जीवनस्य पूरकम्
          </div>
        </div>
      </div>
    </section>
  );
};

export default Ayurvedham;
